import PropertyGallery from './PropertyGallery';

function PropertyHeroSection({ property }) {
  const facilities = Array.isArray(property.facilities) ? property.facilities : [];
  const images = Array.isArray(property.images) && property.images.length > 0
    ? property.images
    : property.imageUrl
      ? [property.imageUrl]
      : [];

  return (
    <section className="grid gap-6 lg:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.8fr)]">
      <div className="overflow-hidden rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] shadow-[0_22px_60px_rgba(24,50,40,0.08)]">
        <PropertyGallery images={images} name={property.name} status={property.status} />
        <div className="px-6 py-8 md:px-8">
          <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Detaljside</p>
          <h1 className="font-serif text-[clamp(2.4rem,4.6vw,4rem)] font-semibold leading-[1.04] text-[#163127]">
            {property.name}
          </h1>
          <p className="mt-3 text-lg text-[#7c6b52]">{property.address}</p>
          <p className="mt-6 max-w-[62ch] text-[1.05rem] leading-[1.8] text-[#355046]">
            {property.summary}
          </p>
          {facilities.length > 0 ? (
            <div className="mt-6">
              <p className="mb-3 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Fasiliteter</p>
              <ul className="flex flex-wrap gap-2">
                {facilities.map((facility) => (
                  <li
                    className="rounded-full border border-[#18322814] bg-[rgba(255,255,255,0.7)] px-4 py-2 text-sm font-semibold text-[#355046]"
                    key={facility}
                  >
                    {facility}
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>
      </div>

      <aside className="rounded-[32px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)] md:p-8">
        <p className="mb-3 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Nokkelinformasjon</p>
        <dl className="grid gap-4">
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Type</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.type}</dd>
          </div>
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Storrelse</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.size}</dd>
          </div>
          {property.rentPerMonth ? (
            <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Manedsleie</dt>
              <dd className="m-0 font-semibold text-[#163127]">{property.rentPerMonth}</dd>
            </div>
          ) : null}
          {property.rooms ? (
            <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Rom</dt>
              <dd className="m-0 font-semibold text-[#163127]">{property.rooms}</dd>
            </div>
          ) : null}
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Tilgjengelighet</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.availableFrom}</dd>
          </div>
          <div className="rounded-[20px] bg-[rgba(255,255,255,0.7)] p-4">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Status</dt>
            <dd className="m-0 font-semibold text-[#163127]">{property.status}</dd>
          </div>
        </dl>
        <div className="mt-6 rounded-[24px] border border-[#18322812] bg-[rgba(255,255,255,0.52)] p-5">
          <p className="mb-2 text-xs uppercase tracking-[0.14em] text-[#7c6b52]">Beliggenhet</p>
          <p className="m-0 text-[1.05rem] leading-[1.7] text-[#355046]">
            Adressen er koblet til kartvisningen under, slik at besokende kan se hvor eiendommen ligger og aapne den direkte i Google Maps.
          </p>
        </div>
        <a
          className="mt-6 inline-flex min-h-12 items-center justify-center rounded-full bg-[#1d4c3b] px-[22px] font-semibold text-[#f9f5ee] no-underline"
          href="#meld-interesse"
        >
          Meld interesse
        </a>
      </aside>
    </section>
  );
}

export default PropertyHeroSection;